import spinner from '../../assets/wired-gradient-105-loader-1 (1)-min.gif';
const Loader = ({ size }) => {
  return <img src={spinner} width={size} height={size} />;
};
Loader.defaultProps = {
  size: 400,
};
export default Loader;
